<template>
  <div v-if="object.type === 'code'">
    <div class="text-right mb-2">
      <div
        class="btn btn-link"
        v-b-tooltip.hover
        :title="`Ctrl-F / Cmd-F
Start searching\n
Ctrl-G / Cmd-G
Find next
Shift-Ctrl-G / Shift-Cmd-G
Find previous
Shift-Ctrl-F / Cmd-Option-F
Replace
Shift-Ctrl-R / Shift-Cmd-Option-F
Replace all
Alt-F
Persistent search (dialog doesn't autoclose, enter to find next, Shift-Enter to find previous)
Alt-G
Jump to line`"
      >
        Shortcuts
        <i class="fas fa-question-circle"></i>
      </div>
    </div>
    <codemirror
      v-model="mutatedObject[field]"
      @blur="blurCodemirror"
      :options="codemirrorOptions"
      @input="validateCodeWithThrottle"
      @change="validateCodeWithThrottle"
      ref="editor"
    ></codemirror>
    <div v-if="codeErrorMessage" class="alert alert-danger my-3" v-html="codeErrorMessage"></div>
  </div>
  <advanced-input
    v-model="mutatedObject[field]"
    :value="mutatedObject[field]"
    :object="object"
    :field="field"
    :type="object.type"
    :maxSymbols="object.maxSymbols"
    :minSymbols="object.minSymbols"
    :max="object.max"
    :min="object.min"
    :required="object.required"
    :decimal="object.decimal"
    :pattern="object.pattern"
    :readonly="object.readonly"
    :id="`advanced-input-${id}`"
    :class="[object.class ? object.class : 'form-control']"
    :placeholder="object.placeholder ? object.placeholder : ''"
    :disabled="object.disabled"
    :validator="object.validator"
    :mask="object.mask || ''"
    autofocus
    v-else-if="field !== 'helpOptions'"
  ></advanced-input>
</template>

<script>
import formComponentsMixin from '@/mixins/formComponentsMixin';
const beautifyHtml = require('js-beautify').html;
import _ from 'lodash';
import { eventBus } from '@/main';

const selfClosedTagsList = [
  'area',
  'base',
  'br',
  'col',
  'command',
  'embed',
  'hr',
  'img',
  'input',
  'keygen',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr'
];
const selfClosedTags = selfClosedTagsList.join('|');

export default {
  data() {
    return {
      editor: null,
      codeErrorMessage: null,
      codemirrorOptions: {
        // extraKeys: {
        //   'Ctrl-Space': 'autocomplete',
        //   'Ctrl-F / Cmd-F': 'findPersistent',
        //   'Ctrl-Q': function (cm) {
        //     cm.foldCode(cm.getCursor());
        //   }
        // },
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],

        extraKeys: { 'Ctrl-Space': 'autocomplete' },
        lineNumbers: true,
        autoCloseTags: true,
        tabMode: 'indent',
        // theme: 'monokai',
        mode: this.object.mode || 'text/html',
        tabSize: 2,
        lineWrapping: true,
        matchClosing: true,
        indentWithTabs: true,
        theme: 'eclipse',
        line: true,
        scrollbarStyle: 'simple'
      },
      validateCodeWithThrottle: _.throttle(this.validateCode, 100, { trailing: false })
    };
  },
  mixins: [formComponentsMixin],
  computed: {
    isHtmlMode() {
      const { type, mode } = this.object || {};
      return type === 'code' && (!mode || mode === 'text/html');
    }
  },
  mounted() {
  this.$nextTick(() => {
    this.editor = this.$refs.editor;

    if (this.editor && this.editor.codemirror) {
      setTimeout(() => {
        this.editor.codemirror.refresh();
      }, 100);
    }

    this.blurCodemirror();

    if (this.isHtmlMode) {
      this.validateCodeWithThrottle();
    }
  });
},
created() {
  if (!this.object.hasOwnProperty('display') || !this.object.display) {
    if (!this.formVisibilityControl) {
      this.$set(this.object, 'display', true);
    } else {
      this.$set(this.object, 'display', !(this.formVisibilityControl !== 'input' && !this.mutatedObject[this.field]));
    }
  }
},
  methods: {
    validateCode() {
      if (!this.isHtmlMode) {
        this.codeErrorMessage = null;
      } else {
        const html = (this.mutatedObject[this.field] || '')
          .trim()
          .replace(/\/\s*>/g, '>')
          .replace(new RegExp(`<(${selfClosedTags})([^>]*)>`, 'g'), '<$1$2/>')
          .replace(/&/g, '&amp;');
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<div>${html}</div>`, 'application/xml');
        const errorNode = doc.querySelector('parsererror');
        this.codeErrorMessage = errorNode?.querySelector('div')?.innerText;
      }

      eventBus.$emit('validateForm', !!this.codeErrorMessage);
    },
    blurCodemirror() {
      this.mutatedObject[this.field] = beautifyHtml(this.mutatedObject[this.field], { indent_size: 2 });
    }
  }
};
</script>
